import type { SVGAttributes } from 'react';
import styles from './RefindIcon.module.css';

interface RefindIconProps extends SVGAttributes<SVGSVGElement> {
  size?: number | string;
}

export const RefindIcon = ({
  size = 32,
  className = '',
  ...props
}: RefindIconProps) => {
  const classNames = [styles.icon, className].filter(Boolean).join(' ');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="273.88 152.07 142.08 134.42"
      width={size}
      height={size}
      className={classNames}
      aria-label="Refind"
      {...props}
    >
      <path
        fill="currentColor"
        d="M368.47,239.39V191.9h-94.59l39.64-39.83h102.44v87.32H368.47z M273.88,286.49v-87.32h47.49v87.32H273.88z"
      />
    </svg>
  );
};

